/* Verlichtingshuis, Q4 2026 theme behaviour. Plain JS, no dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const VH = window.VH || {};
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function money(cents) {
    const f = (VH.moneyFormat || '€{{amount_with_comma_separator}}').replace(/<[^>]*>/g, '');
    const n = (cents / 100);
    const fix = (d, t, dec) => { const p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(dec); };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fix(2, ',', '.'), amount_no_decimals: fix(0, ',', '.'),
      amount_with_comma_separator: fix(2, '.', ','), amount_no_decimals_with_comma_separator: fix(0, '.', ','),
      amount_with_apostrophe_separator: fix(2, "'", '.')
    })[k] || fix(2, '.', ','));
  }
  VH.money = money;

  /* ---------- season (date-driven; ?s=sint previews another window) ---------- */
  const SEASONS = VH.seasons || { herfst: ['2026-01-01', '2026-10-25'], sint: ['2026-10-26', '2026-11-07'], winter: ['2026-11-08', '2026-11-15'], bf: ['2026-11-16', '2026-11-26'], na: ['2026-11-27', '2027-01-15'] };
  const today = new Date(); const iso = today.toISOString().slice(0, 10);
  let season = 'herfst';
  for (const [k, [a, b]] of Object.entries(SEASONS)) if (iso >= a && iso <= b) season = k;
  const qs = new URLSearchParams(location.search);
  if (qs.get('s') && SEASONS[qs.get('s')]) { season = qs.get('s'); try { sessionStorage.setItem('vh-s', season) } catch (e) {} }
  else { try { const s = sessionStorage.getItem('vh-s'); if (s && SEASONS[s]) season = s } catch (e) {} }
  document.body.classList.add('s-' + season);
  // past cut-off dates get struck
  $$('[data-until]').forEach(el => { if (iso > el.dataset.until && !qs.get('s')) el.classList.add('is-past') });

  /* ---------- delivery window: 3–4 weeks, counted in working days ---------- */
  function addWorkdays(d, n) { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) n--; } return x; }
  const fmt = d => d.toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' });
  const [lo, hi] = VH.leadDays || [15, 20];
  $$('[data-deliv]').forEach(el => { el.textContent = fmt(addWorkdays(today, lo)) + ' en ' + fmt(addWorkdays(today, hi)) });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target) } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.vh-rv').forEach(el => io.observe(el));
  } else $$('.vh-rv').forEach(el => el.classList.add('is-in'));

  /* ---------- videos: play only while visible; pick the small source on phones ---------- */
  const small = matchMedia('(max-width: 760px)').matches;
  function prime(v) {
    if (v.dataset.primed) return; v.dataset.primed = 1;
    const src = (small && v.dataset.srcM) || v.dataset.src;
    if (src) { v.src = src; v.load(); }
  }
  if ('IntersectionObserver' in window) {
    const vio = new IntersectionObserver(es => es.forEach(e => {
      const v = e.target;
      if (e.isIntersecting) { prime(v); if (!reduce && v.dataset.auto !== 'hover' && !v.dataset.done) v.play().catch(() => {}); }
      else if (!v.paused) v.pause();
    }), { rootMargin: '200px 0px' });
    $$('video[data-vh]').forEach(v => vio.observe(v));
  }
  $$('[data-hoverplay]').forEach(card => {
    const v = $('video', card); if (!v || matchMedia('(hover: none)').matches) return;
    card.addEventListener('mouseenter', () => { prime(v); v.currentTime = 0; v.play().catch(() => {}); v.style.opacity = 1 });
    card.addEventListener('mouseleave', () => { v.pause(); v.style.opacity = 0 });
  });
  $$('.vh-vid__play').forEach(b => b.addEventListener('click', () => {
    const v = $('video', b.closest('.vh-vid')); if (!v) return; prime(v);
    if (v.paused) { v.play(); b.setAttribute('aria-label', 'Pauze') } else { v.pause(); b.setAttribute('aria-label', 'Afspelen') }
  }));

  /* ---------- lamp switch (hero): video plays off→on once, then the switch takes over ---------- */
  $$('[data-lamp]').forEach(root => {
    const lamp = $('.vh-lamp', root), sw = $('.vh-switch', root), vid = $('video', root), lbl = $('.vh-switch__lbl', root);
    const set = on => { lamp.classList.toggle('is-lit', on); sw.setAttribute('aria-pressed', on); if (lbl) lbl.textContent = on ? 'Lamp aan' : 'Lamp uit'; };
    if (vid && !reduce) {
      vid.addEventListener('ended', () => { vid.dataset.done = 1; lamp.classList.add('is-lit'); vid.style.transition = 'opacity .6s'; vid.style.opacity = 0; set(true); });
      vid.addEventListener('playing', () => { set(true) }, { once: true });
    } else { if (vid) vid.remove(); setTimeout(() => set(true), 900); }
    sw.addEventListener('click', () => {
      if (vid && vid.style.opacity !== '0') { vid.pause(); vid.style.opacity = 0; vid.dataset.done = 1; }
      set(sw.getAttribute('aria-pressed') !== 'true');
    });
  });

  /* ---------- before/after slider ---------- */
  $$('.vh-ba').forEach(ba => {
    const r = $('input[type=range]', ba);
    const set = v => { ba.style.setProperty('--pos', v + '%'); r.value = v; ba.setAttribute('aria-valuenow', v) };
    r.addEventListener('input', () => { ba.classList.add('is-touched'); set(r.value) });
    let drag = false;
    const at = e => { const b = ba.getBoundingClientRect(); const x = (e.touches ? e.touches[0].clientX : e.clientX); return Math.max(0, Math.min(100, (x - b.left) / b.width * 100)) };
    ba.addEventListener('pointerdown', e => { drag = true; ba.classList.add('is-drag', 'is-touched'); set(at(e)); ba.setPointerCapture && ba.setPointerCapture(e.pointerId) });
    ba.addEventListener('pointermove', e => { if (drag) set(at(e)) });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(t => ba.addEventListener(t, () => { drag = false; ba.classList.remove('is-drag') }));
    // a one-time hint sweep when it first scrolls into view: 50 → 78 → 22 → 50
    if (!reduce && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => { if (!es[0].isIntersecting) return; io.disconnect();
        if (ba.classList.contains('is-touched')) return;
        const keys = [[0, 50], [700, 80], [1500, 22], [2300, 50]]; const t0 = performance.now();
        const step = t => { if (ba.classList.contains('is-touched')) return; const dt = t - t0;
          let i = keys.findIndex(k => k[0] > dt); if (i < 0) { set(50); return; }
          const [a0, v0] = keys[i - 1], [a1, v1] = keys[i]; const p = (dt - a0) / (a1 - a0); const ease = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
          set(v0 + (v1 - v0) * ease); requestAnimationFrame(step) };
        setTimeout(() => requestAnimationFrame(step), 400);
      }, { threshold: .6 });
      io.observe(ba);
    }
  });

  /* ---------- header: sticky shadow, drawers, search ---------- */
  const header = $('.vh-header');
  if (header) { const s = $('#header-scroll-tracker') || document.body; new IntersectionObserver(e => header.classList.toggle('is-stuck', !e[0].isIntersecting)).observe(s) }
  const drawers = {};
  function openDrawer(id) { const d = $('#' + id); if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; drawers.cur = d; setTimeout(() => { const f = $('[autofocus], button, a, input', d.querySelector('.vh-drawer__panel') || d); f && f.focus() }, 50) }
  function closeDrawer(d = drawers.cur) { if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; drawers.cur = null }
  VH.openDrawer = openDrawer; VH.closeDrawer = closeDrawer;
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-open]'); if (o) { e.preventDefault(); openDrawer(o.dataset.open); if (o.dataset.open === 'vh-cart') renderCart(); }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeDrawer(e.target.closest('.vh-drawer, .vh-search, .vh-cside') ? undefined : undefined); const s = e.target.closest('.vh-search'); if (s) closeSearch(); const c = e.target.closest('.vh-cside'); if (c) c.classList.remove('is-open'); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawer(); closeSearch() } });

  const search = $('#vh-search');
  function openSearch() { if (!search) return; search.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; setTimeout(() => $('input', search).focus(), 60) }
  function closeSearch() { if (!search) return; search.classList.remove('is-open'); document.documentElement.style.overflow = '' }
  $$('[data-search]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openSearch() }));
  if (search) {
    const inp = $('input[name=q]', search), out = $('.vh-search__res', search); let t;
    inp.addEventListener('input', () => { clearTimeout(t); t = setTimeout(async () => {
      const q = inp.value.trim(); if (q.length < 2) { out.innerHTML = ''; return; }
      try {
        const r = await fetch(`${VH.routes.search}/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`);
        const j = await r.json(); const ps = j.resources.results.products || [];
        out.innerHTML = ps.length ? ps.map(p => `<a class="vh-card" href="${p.url}"><div class="vh-card__media">${p.image ? `<img src="${p.image}&width=400" alt="" loading="lazy">` : ''}</div><div class="vh-card__body"><p class="vh-card__title">${p.title}</p><div class="vh-price"><span class="vh-price__now">${money(Math.round(parseFloat(p.price) * 100))}</span></div></div></a>`).join('')
          : `<p class="vh-mute">Niets gevonden voor “${q.replace(/</g, '')}”. Probeer “hanglamp”, “wandlamp” of “bauhaus”.</p>`;
      } catch (e) {}
    }, 180) });
  }

  /* ---------- cart ---------- */
  const cartEl = $('#vh-cart');
  const toast = msg => { let t = $('.vh-toast'); if (!t) { t = document.createElement('div'); t.className = 'vh-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t) } t.textContent = msg; t.classList.add('is-on'); clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('is-on'), 2600) };
  async function getCart() { return (await fetch(VH.routes.cart + '.js', { headers: { Accept: 'application/json' } })).json() }
  function setCount(n) { $$('.vh-count').forEach(c => { c.textContent = n; c.dataset.count = n }) }
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  function lineHTML(it, i) {
    const opts = (it.options_with_values || []).filter(o => o.name !== 'Title').map(o => esc(o.value)).join(' · ');
    const was = it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : '';
    return `<div class="vh-line" data-line="${i + 1}"><a href="${it.url}"><img src="${it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=240' : ''}" alt="" loading="lazy"></a>
      <div><a class="vh-line__t" href="${it.url}">${esc(it.product_title)}</a>${opts ? `<div class="vh-line__v">${opts}</div>` : ''}
      <div class="vh-line__row"><div class="vh-qty"><button type="button" data-q="-1" aria-label="Minder">−</button><input type="number" min="0" value="${it.quantity}" aria-label="Aantal" readonly><button type="button" data-q="1" aria-label="Meer">+</button></div>
      <button class="vh-line__rm" type="button" data-q="0">Verwijderen</button></div></div>
      <div class="vh-line__p">${money(it.final_line_price)}${was}</div></div>`;
  }
  async function upsell(cart) {
    const box = $('[data-upsell]', cartEl); if (!box || !cart.items.length) { if (box) box.innerHTML = ''; return; }
    try {
      const r = await fetch(`${VH.routes.recs}.json?product_id=${cart.items[0].product_id}&limit=4&intent=complementary`); let j = await r.json();
      let ps = (j.products || []);
      if (!ps.length) { j = await (await fetch(`${VH.routes.recs}.json?product_id=${cart.items[0].product_id}&limit=4`)).json(); ps = j.products || [] }
      const inCart = new Set(cart.items.map(i => i.product_id));
      ps = ps.filter(p => !inCart.has(p.id) && p.available).slice(0, 2);
      box.innerHTML = ps.length ? `<h4>Maak de kamer af</h4>` + ps.map(p => `<div class="vh-up"><img src="${p.featured_image}&width=160" alt="" loading="lazy"><div><b>${esc(p.title)}</b><span class="vh-xs vh-mute">${money(p.price)}</span></div>
        <a class="vh-btn vh-btn--ghost" href="${p.url}">Bekijk</a></div>`).join('') : '';
    } catch (e) {}
  }
  async function renderCart(cart) {
    if (!cartEl) return; cart = cart || await getCart(); setCount(cart.item_count);
    const body = $('[data-cart-body]', cartEl), foot = $('[data-cart-foot]', cartEl);
    if (!cart.item_count) { body.innerHTML = $('#vh-cart-empty').innerHTML; foot.hidden = true; return; }
    foot.hidden = false;
    body.innerHTML = cart.items.map(lineHTML).join('') + $('#vh-cart-after').innerHTML;
    $$('[data-deliv]', body).forEach(el => el.textContent = fmt(addWorkdays(today, lo)) + ' en ' + fmt(addWorkdays(today, hi)));
    $('[data-subtotal]', cartEl).textContent = money(cart.total_price);
    const note = $('textarea[name=note]', body); if (note) { note.value = cart.note || ''; if (cart.note) note.closest('details').open = true; }
    upsell(cart);
  }
  VH.renderCart = renderCart;
  async function change(line, qty) {
    const r = await fetch(VH.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity: qty }) });
    const c = await r.json(); if (document.body.classList.contains('t-cart')) location.reload(); else renderCart(c);
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-line] [data-q]'); if (!b) return;
    const row = b.closest('[data-line]'); const cur = +$('input', row).value; const d = +b.dataset.q;
    change(+row.dataset.line, d === 0 ? 0 : Math.max(0, cur + d));
  });
  let noteT; document.addEventListener('input', e => {
    if (e.target.name !== 'note' || !e.target.closest('#vh-cart, .vh-cart')) return;
    clearTimeout(noteT); noteT = setTimeout(() => fetch(VH.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) }), 500);
  });
  async function add(form) {
    const btn = $('[type=submit]', form); btn && btn.classList.add('is-loading');
    try {
      const r = await fetch(VH.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const j = await r.json();
      if (j.status) { toast(j.description || j.message || 'Dit kon niet worden toegevoegd'); return; }
      if (VH.cartType === 'page') { location.href = VH.routes.cart; return; }
      await renderCart(); openDrawer('vh-cart');
    } catch (err) { form.submit(); }
    finally { btn && btn.classList.remove('is-loading'); }
  }
  document.addEventListener('submit', e => { const f = e.target; if (f.matches('form[data-vh-add]')) { e.preventDefault(); add(f); } });
  if (cartEl) getCart().then(c => setCount(c.item_count));

  /* ---------- PDP: gallery + variant logic ---------- */
  const pdp = $('[data-pdp]');
  if (pdp) {
    const P = JSON.parse($('script[data-product-json]', pdp).textContent);
    const slides = $$('.vh-gal__slide', pdp), thumbs = $$('.vh-gal__thumb', pdp), dots = $$('.vh-gal__dots button', pdp);
    let cur = 0;
    const show = i => {
      i = (i + slides.length) % slides.length; cur = i;
      slides.forEach((s, k) => { s.classList.toggle('is-on', k === i); const v = $('video', s); if (v) { if (k === i) { prime(v); v.play().catch(() => {}) } else v.pause() } });
      thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i)); dots.forEach((t, k) => t.classList.toggle('is-on', k === i));
      const gi = $('[data-gal-i]', pdp); if (gi) gi.textContent = i + 1;
      const th = thumbs[i]; th && th.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i))); dots.forEach((t, i) => t.addEventListener('click', () => show(i)));
    $('.vh-gal__nav--p', pdp)?.addEventListener('click', () => show(cur - 1)); $('.vh-gal__nav--n', pdp)?.addEventListener('click', () => show(cur + 1));
    let sx = null; const st = $('.vh-gal__stage', pdp);
    st && st.addEventListener('touchstart', e => sx = e.touches[0].clientX, { passive: true });
    st && st.addEventListener('touchend', e => { if (sx == null) return; const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); sx = null });
    const byMedia = id => slides.findIndex(s => s.dataset.media == id);

    const form = $('form[data-vh-add]', pdp), idIn = $('input[name=id]', form);
    const sel = () => P.options.map((_, i) => { const c = $(`input[name="opt${i}"]:checked`, pdp); return c ? c.value : null });
    const priceEls = $$('[data-price-now]'), wasEls = $$('[data-price-was]'), btns = $$('[data-atc-label]');
    const showWas = pdp.dataset.event === '1';
    function update(fromUser) {
      const s = sel();
      const v = P.variants.find(v => v.options.every((o, i) => o === s[i]));
      // mark combos that do not exist / are sold out, given the other choices
      P.options.forEach((_, i) => $$(`input[name="opt${i}"]`, pdp).forEach(inp => {
        const ok = P.variants.some(v => v.available && v.options.every((o, j) => j === i ? o === inp.value : o === s[j]));
        inp.classList.toggle('is-na', !ok);
      }));
      $$('[data-opt-val]', pdp).forEach(el => el.textContent = s[+el.dataset.optVal] || '');
      const choice = $('[data-choice]', pdp);
      if (choice) choice.innerHTML = 'Jouw keuze: <b>' + s.filter(x => x && x !== 'Default Title').map(esc).join(' · ') + '</b>';
      if (!v) { btns.forEach(b => { b.textContent = 'Deze combinatie bestaat niet'; b.closest('button').disabled = true }); return; }
      idIn.value = v.id;
      priceEls.forEach(e => e.textContent = money(v.price));
      wasEls.forEach(e => { e.hidden = false; e.textContent = money(Math.round(v.price / 0.7)) });
      btns.forEach(b => { const bt = b.closest('button'); bt.disabled = !v.available; b.textContent = v.available ? (b.dataset.atcLabel + ', ' + money(v.price)) : 'Tijdelijk niet leverbaar' });
      if (fromUser) {
        history.replaceState(null, '', location.pathname + '?variant=' + v.id);
        if (v.featured_media) { const i = byMedia(v.featured_media.id); if (i > -1) show(i); }
      }
      const sImg = $('.vh-sticky__img', document); if (sImg && v.featured_image) sImg.src = v.featured_image.src + '&width=120';
    }
    pdp.addEventListener('change', e => { if (e.target.name && e.target.name.startsWith('opt')) update(true) });
    update(false);
    // quantity
    $$('.vh-qty', pdp).forEach(q => { const i = $('input', q); $$('button', q).forEach(b => b.addEventListener('click', () => { i.value = Math.max(1, (+i.value || 1) + (+b.dataset.step)) })) });
    // sticky ATC
    const sticky = $('.vh-sticky'), atc = $('.vh-atc', pdp);
    if (sticky && atc) {
      document.body.classList.add('has-sticky');
      new IntersectionObserver(e => sticky.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0)).observe(atc);
      $('button', sticky).addEventListener('click', () => { form.requestSubmit ? form.requestSubmit() : $('[type=submit]', form).click() });
    }
  }

  /* ---------- collection: filters ---------- */
  const facets = $('#vh-facets');
  if (facets) {
    const submit = () => { const fd = new FormData(facets); const p = new URLSearchParams();
      for (const [k, v] of fd) if (v !== '') p.append(k, v);
      location.search = p.toString(); };
    if (!matchMedia('(max-width: 1000px)').matches) facets.addEventListener('change', e => { if (e.target.type !== 'number') submit() });
    facets.addEventListener('submit', e => { e.preventDefault(); submit() });
    $$('[data-sort]').forEach(s => s.addEventListener('change', () => { const p = new URLSearchParams(location.search); p.set('sort_by', s.value); location.search = p.toString() }));
    $$('[data-filters-open]').forEach(b => b.addEventListener('click', () => $('.vh-cside').classList.add('is-open')));
  }
})();
